/* globals angular */
(function(){
  'use strict';

  var reversesList = {
    template: require('./reverse-list.html'),
    controller: 'ReverseListCtrl',
  };

  angular
    .module('mandaeApp')
    .component('reversesList', reversesList)
    .config(['$qProvider', '$stateProvider', function($qProvider, $stateProvider) {
      $qProvider.errorOnUnhandledRejections(false);
      $stateProvider
        // url will be app/historico/encomendas
        .state('reverse-list', {
          parent: 'historico',
          url: '/reversas',
          component: 'reversesList',
        });
    }]);

}());
